import React, { useCallback, useEffect, useState } from "react";
import { useCheckoutContext } from "lib/contexts/CheckoutProvider";
import { useAuthContext } from "lib/contexts/AuthProvider";
import { useMerchantContext } from "lib/contexts/MerchantProvider";
import { useIsSubscribeMode } from "lib/hooks/useIsSubscribeMode";

interface GenericBannerStripProps {
  bannerType?: string;
}

const GenericBannerStrip: React.FC<GenericBannerStripProps> = React.memo(({ bannerType }) => {
  const {
    state: { checkoutView },
  } = useCheckoutContext();
  const {
    state: { checkoutMetadata, merchant },
  } = useMerchantContext();
  const {
    state: { isAuthenticated },
  } = useAuthContext();

  const isSubscribeMode = useIsSubscribeMode();

  const [isBannerEnabled, setIsBannerEnabled] = useState<boolean>(true);
  const [bannerHtmlStr, setBannerHtmlStr] = useState<string>("");
  const [bannerBg, setBannerBg] = useState<string>("");
  const [textColor, setTextColor] = useState<string>("");

  useEffect(() => {
    if (checkoutMetadata) {
      setBannerStates();
    }
  }, [checkoutMetadata, checkoutView, isSubscribeMode]);

  const setBannerStates = () => {
    let htmlStr = "";
    let bgColor = "";
    let txtColor = "";
    let isEnabled = false;

    let showBannerType = bannerType;

    if (!bannerType) {
      const isSinglePageCheckout = merchant?.isOnePageCheckout;
      if (isSinglePageCheckout) {
        showBannerType = "PAYMENTS";
      } else {
        // If checkout view is not loaded means user is on address list page where fetch API is made
        showBannerType = checkoutView === "NA" ? "ORDER_SUMMARY" : checkoutView;
      }
    }

    if (checkoutView === "ADDRESS_LIST") {
      showBannerType = "ORDER_SUMMARY";
    }

    if (!isAuthenticated) {
      showBannerType = "AUTH";
    }

    const findBanner = (type?: string) =>
      checkoutMetadata?.uiAttributes?.bannerConfig?.find((banner: any) => banner.type === type);

    // The payments banner is configured per purchase mode; fall back only when no row exists.
    let currentCheckoutViewBanner =
      isSubscribeMode && showBannerType === "PAYMENTS"
        ? findBanner("PAYMENTS_SUBSCRIBE") ?? findBanner(showBannerType)
        : findBanner(showBannerType);

    if (Boolean(currentCheckoutViewBanner)) {
      htmlStr = currentCheckoutViewBanner?.htmlTextString ?? "";
      bgColor = `${currentCheckoutViewBanner?.backgroundColor ?? "black"}`;
      txtColor = `${currentCheckoutViewBanner?.textColor ?? "white"}`;
      isEnabled = currentCheckoutViewBanner?.enabled ?? false;
    }

    setBannerHtmlStr(htmlStr);
    setBannerBg(bgColor);
    setTextColor(txtColor);
    setIsBannerEnabled(isEnabled);
  };

  useEffect(() => {
    document?.documentElement?.style?.setProperty("--flo-bannerstrip-bg-color", `${bannerBg}`);
    document?.documentElement?.style?.setProperty("--flo-bannerstrip-txt-color", `${textColor}`);
  }, [bannerBg, textColor]);

  if (!isBannerEnabled || !Boolean(checkoutMetadata?.uiAttributes?.bannerConfig)) return <></>;
  return (
    <div
      className={`bannerStripClass sticky top-0 z-20 flex  min-h-[26px]  w-full items-center justify-center px-3 text-center text-text-xs-semibold`}
      dangerouslySetInnerHTML={{ __html: bannerHtmlStr }}></div>
  );
});

export default GenericBannerStrip;
